import { useEffect, useState } from "react";
import { PlayCircle, ChevronDown, ChevronUp } from "lucide-react";
import api from "../lib/api";

export default function Editions() {
  const [editions, setEditions] = useState([]);
  const [open, setOpen] = useState(null);
  const [activeVideo, setActiveVideo] = useState(null);

  useEffect(() => {
    api.get("/editions").then((res) => setEditions(res.data)).catch(() => {});
  }, []);

  return (
    <div data-testid="editions-page" className="space-y-6">
      <div>
        <p className="text-xs font-data tracking-[0.3em] uppercase text-[#00C8FF] mb-2">Memória do evento</p>
        <h1 className="text-3xl sm:text-4xl font-bold tracking-tight text-white">Edições Anteriores</h1>
        <p className="text-base text-slate-300 mt-2">Assista novamente às palestras das edições passadas do Pregoeiros Summit.</p>
      </div>

      {editions.length === 0 && (
        <div className="card-room text-slate-400 text-sm">As gravações das edições anteriores serão publicadas em breve.</div>
      )}

      <div className="space-y-4">
        {editions.map((ed) => (
          <div key={ed.id} className="card-room !p-0 overflow-hidden" data-testid={`edition-card-${ed.year}`}>
            <button onClick={() => setOpen(open === ed.id ? null : ed.id)}
              className="w-full flex items-center justify-between p-6 text-left"
              data-testid={`edition-toggle-${ed.year}`}>
              <div>
                <span className="text-xs font-data tracking-widest uppercase text-[#F5A623]">{ed.year}</span>
                <h2 className="text-xl sm:text-2xl font-semibold text-white mt-1">{ed.title}</h2>
                {ed.description && <p className="text-sm text-slate-400 mt-1">{ed.description}</p>}
              </div>
              <span className="text-[#00C8FF] ml-4 shrink-0">
                {open === ed.id ? <ChevronUp size={22} /> : <ChevronDown size={22} />}
              </span>
            </button>
            {open === ed.id && (
              <div className="border-t border-[#00C8FF]/15 p-6 grid grid-cols-1 md:grid-cols-2 gap-4">
                {ed.videos.map((v, i) => (
                  <div key={v.vimeo_url || v.title}>
                    {activeVideo === `${ed.id}-${i}` ? (
                      <div className="rounded-lg overflow-hidden border border-[#00C8FF]/30 bg-black aspect-video" data-testid="edition-video-player">
                        <iframe src={v.embed_url} className="w-full h-full" frameBorder="0"
                          allow="autoplay; fullscreen; picture-in-picture" allowFullScreen title={v.title} />
                      </div>
                    ) : (
                      <button onClick={() => setActiveVideo(`${ed.id}-${i}`)}
                        className="w-full aspect-video rounded-lg border border-[#00C8FF]/25 gradient-brand flex flex-col items-center justify-center gap-2 hover:border-[#00C8FF]/60 transition-colors group"
                        data-testid={`edition-video-${ed.year}-${i}`}>
                        <PlayCircle size={44} className="text-[#00C8FF] group-hover:scale-110 transition-transform" />
                        <span className="text-sm font-semibold text-white px-4 text-center">{v.title}</span>
                      </button>
                    )}
                    <p className="text-xs text-slate-400 mt-2">{v.title}</p>
                  </div>
                ))}
                {ed.videos.length === 0 && <p className="text-sm text-slate-500">Nenhum vídeo cadastrado nesta edição.</p>}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
